import * as React from 'react';
import { t } from 'i18next';

import { HamburgerTab } from '../../constants/Enums';
import { BaseHamburgerTab } from './BaseHamburgerTab';
import { HamburgerContentWrapper } from './HamburgerContentWrapper';

export class CustomProductOverviewTab extends BaseHamburgerTab<{}> {
    protected previous: HamburgerTab = HamburgerTab.HELP;
    public getLabel(): string {
        return t('BLANCOTHERM K synthetic product overview');
    }

    public render(): React.ReactElement<{}> {
        // if (AppConfigurationStore.getState().inApp) {
        // 	return (
        // 		<div className={this._getCSSClass() + " customer-product-overview"}>
        // 			{this._header()}
        // 			<div className="sidebar-content scrollbar-wcf">
        // 				<IOSScrollFix ref="ios-scroll-1"/>
        // 				<div className="sidebar-content-wrapper">
        // 					{this._getTable()}
        // 				</div>
        // 			</div>
        // 		</div>
        // 	);
        // }
        // return (
        // 	<div className={this._getCSSClass() + " customer-product-overview"}>
        // 		{this._header()}
        // 		<div className="sidebar-content">
        // 			{this._getTable()}
        // 		</div>
        // 	</div>
        // );
        return (
            <HamburgerContentWrapper className={this.getCSSClass() + ' custom-product-overview'} header={this.header()}>
                {this.getTable()}
            </HamburgerContentWrapper>
        );
    }

    protected getTable = (): JSX.Element => {
        return (
            <div className="custom-product-overview-wrapper">
                <div className="scrollbar-wcf custom-scrollbar-wcf">
                    <div className="scrollbar-wrapper">
                        <table className="custom-product-overview-table">
                            <tr>
                                <td>{t('Model')}</td>
                                <td>{t('unheated')}</td>
                                <td>{t('heatable')}</td>
                                <td>{t('heatable and adjustable')}</td>
                            </tr>
                            <tr>
                                <td>{t('Top loaders')} =<br/>{t('(Top loaders)')}</td>
                                <td>BLT 160 K<br/>BLT 320 K<br/>BLT 320 ECO<br/>BLT 320 ECO-C</td>
                                <td><u>{t('Silicone heating')}:</u><br/>BLT 320 KB</td>
                                <td><u>{t('Silicone heating')}:</u><br/>BLT 320 KBR</td>
                            </tr>
                            <tr>
                                <td>{t('Front loaders')} =<br/>{t('(Front loaders)')}</td>
                                <td>BLT 420 K<br/>BLT 620 KUF<br/>BLT 620 KUF-F<br/>BLT 620 KUS<br/>BLT 620 KF<br/>BLT 620 KV</td>
                                <td><u>{t('Convection heating')}:</u><br/>BLT 420 KBUH<br/>BLT 620 KBUH<br/>BLT 620 KBUH-F</td>
                                <td><u>{t('Convection heating')}:</u><br/>BLT 420 KBRUH<br/>BLT 620 KBRUH<br/>BLT 620 KBRUH-F</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <table className="custom-product-overview-legend-table">
                    <tr>
                        <td colSpan={3}>{t('Model designations')}</td>
                    </tr>
                    <tr>
                        <td>BLT</td>
                        <td>=</td>
                        <td>BLANCOTHERM</td>
                    </tr>
                    <tr>
                        <td>K</td>
                        <td>=</td>
                        <td>{t('Synthetic')}</td>
                    </tr>
                    <tr>
                        <td>KB</td>
                        <td>=</td>
                        <td>{t('Synthetic')}, {t('heatable')}</td>
                    </tr>
                    <tr>
                        <td>KBR</td>
                        <td>=</td>
                        <td>{t('Synthetic')}, {t('heatable')}, {t('adjustable')}</td>
                    </tr>
                    <tr>
                        <td>KBUH</td>
                        <td>=</td>
                        <td>{t('Synthetic')}, {t('heatable')}, {t('convection heating')}</td>
                    </tr>
                    <tr>
                        <td>KBRUH</td>
                        <td>=</td>
                        <td>{t('Synthetic')}, {t('heatable')}, {t('adjustable')}, {t('convection heating')}</td>
                    </tr>
                    <tr>
                        <td>KF</td>
                        <td>=</td>
                        <td>{t('Synthetic')}, {t('mobile')}</td>
                    </tr>
                    <tr>
                        <td>KUF</td>
                        <td>=</td>
                        <td>{t('Synthetic')}, {t('unheated')}, {t('hinged door')}</td>
                    </tr>
                    <tr>
                        <td>KUS</td>
                        <td>=</td>
                        <td>{t('Synthetic')}, {t('unheated')}, {t('removable door')}</td>
                    </tr>
                    <tr>
                        <td>KV</td>
                        <td>=</td>
                        <td>{t('Synthetic')}, {t('lock on top')}</td>
                    </tr>
                    <tr>
                        <td>-F</td>
                        <td>=</td>
                        <td>{t('Mobile')}</td>
                    </tr>
                    <tr>
                        <td>-C</td>
                        <td>=</td>
                        <td>{t('Catering')}</td>
                    </tr>
                </table>
            </div>
        );
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/CustomProductOverviewTab.tsx